import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmergencyContactCard = () => {
  const handlePhoneClick = () => {
    window.location.href = 'tel:0827935785';
  };

  const handleSMSClick = () => {
    window.location.href = 'sms:0827935785';
  };

  const emergencyServices = [
    {
      icon: "Droplet",
      title: "Burst Pipes",
      description: "Immediate leak detection and repair"
    },
    {
      icon: "Zap",
      title: "Electrical Faults",
      description: "Emergency power restoration"
    },
    {
      icon: "Flame",
      title: "Gas Leaks",
      description: "Urgent safety response"
    },
    {
      icon: "AlertTriangle",
      title: "System Failures",
      description: "Critical infrastructure repairs"
    }
  ];

  return (
    <div className="bg-error text-error-foreground rounded-lg p-6 md:p-8 shadow-elevated">
      <div className="flex items-start gap-4 mb-6">
        <div className="flex-shrink-0 w-12 h-12 md:w-16 md:h-16 bg-error-foreground text-error rounded-full flex items-center justify-center">
          <Icon name="AlertCircle" size={24} className="md:w-8 md:h-8" />
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="font-headline font-bold text-xl md:text-2xl lg:text-3xl mb-2">
            Emergency Service
          </h2>
          <p className="font-body text-sm md:text-base opacity-90">
            Immediate response for urgent plumbing and electrical emergencies
          </p>
        </div>
      </div>
      <div className="bg-error-foreground text-error rounded-lg p-4 md:p-6 mb-6">
        <div className="text-center mb-4">
          <p className="font-body text-sm md:text-base mb-2 opacity-80">Call Now for Immediate Help</p>
          <a
            href="tel:0827935785"
            className="font-accent font-bold text-3xl md:text-4xl lg:text-5xl hover:opacity-80 transition-opacity"
          >
            082 793 5785
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
          <Button
            variant="default"
            size="lg"
            onClick={handlePhoneClick}
            className="w-full bg-error hover:bg-error/90 text-error-foreground emergency-cta"
            iconName="Phone"
            iconPosition="left"
          >
            Call Now
          </Button>

          <Button
            variant="outline"
            size="lg"
            onClick={handleSMSClick}
            className="w-full border-error text-error hover:bg-error hover:text-error-foreground"
            iconName="MessageSquare"
            iconPosition="left"
          >
            Send SMS
          </Button>
        </div>
      </div>
      <div className="space-y-3 md:space-y-4">
        <h3 className="font-headline font-semibold text-lg md:text-xl mb-3 md:mb-4">
          We Handle:
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
          {emergencyServices?.map((service, index) => (
            <div key={index} className="flex items-start gap-3 bg-error-foreground/10 rounded-lg p-3 md:p-4">
              <Icon name={service?.icon} size={20} className="flex-shrink-0 mt-1" />
              <div className="flex-1 min-w-0">
                <h4 className="font-headline font-semibold text-sm md:text-base mb-1">
                  {service?.title}
                </h4>
                <p className="font-body text-xs md:text-sm opacity-80">
                  {service?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-6 pt-6 border-t border-error-foreground/20">
        <div className="flex items-center gap-2 text-sm md:text-base">
          <Icon name="Clock" size={18} />
          <span className="font-body">Average response time: 30-45 minutes</span>
        </div>
      </div>
    </div>
  );
};

export default EmergencyContactCard;